<template>
    <v-row class="column fill-height" v-if="hasSelectedGarage()">
        <v-col cols="10" class="pa-0">
            <v-container fill-height fluid>
                <v-row dense class="column fill-height">
                    <v-col cols="3">
                        <div class="title">Services</div>
                        <services></services>
                    </v-col>
                    <v-col cols="3">
                        <div class="title">Defects</div>
                        <defects></defects>
                    </v-col>
                    <v-col cols="3">
                        <div class="title">Date-Based Tasks</div>
                        <date-based-tasks></date-based-tasks>
                    </v-col>
                    <v-col cols="3">
                        <div class="title">Campaigns</div>
                        <campaigns></campaigns>
                    </v-col>
                </v-row>
            </v-container>
        </v-col>
        <v-col cols="2" class="px-0 py-5">
            <units-summary :from="from" :to="to" period="day"></units-summary>
        </v-col>
    </v-row>
    <v-row v-else class="column fill-height">
        <v-col>
            <v-alert type="warning" class="ma-5">You have not selected a Garage Location</v-alert>
        </v-col>
    </v-row>
</template>
<script>
import { VclFacebook } from 'vue-content-loading';
import Controls from './Day/Controls.vue';
import Services from './Day/Services.vue';
import Defects from './Day/Defects.vue';
import Campaigns from './Day/Campaigns.vue';
import DateBasedTasks from './Day/DateBasedTasks.vue';
import UnitsSummary from '@/components/GarageLocations/UnitsSummary';
import GarageLocations from '@/components/GarageLocations/GarageLocationsClient.vue';

export default {
    mixins: [Controls, GarageLocations],
    components: {
        Services,
        Defects,
        DateBasedTasks,
        Campaigns,
        UnitsSummary
    },
    async mounted() {
        await this.loadUserGarages();
    }
};
</script>
